import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useState } from "react";
import { toast } from "sonner";
import { AxiosError } from "axios";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select/select";

import { useTakeActionModal } from "./use-action-modal";
import { Button } from "@/components/ui/button/button";
import { takeActionOnLeaveApplicationAsApprover } from "@/config/mutation/approver";

export const TakeActionOnOthersLeaveApplicationModal = () => {
  const queryClient = useQueryClient();
  const key = Cookies.get("key") as string;
  const { open, onOpenChange, leaveId } = useTakeActionModal();

  const [value, setValue] = useState("");

  const { mutate, isPending } = useMutation({
    mutationFn: takeActionOnLeaveApplicationAsApprover(key),
  });

  const submitAction = async () => {
    if (!value || value === undefined) {
      return toast.error("Please select an action first.");
    }

    mutate(
      {
        leaveId,
        status: value,
      },
      {
        onSuccess: async () => {
          // console.log("New Employee", data);
          await queryClient.invalidateQueries({
            queryKey: ["employee", "leave-applications", "approver"],
          });
          await queryClient.invalidateQueries({
            queryKey: ["leave-applications"],
          });

          toast.success("Action Taken.");
          onOpenChange(false);
        },

        onError: (error) => {
          console.log("ERROR WHILE CREATING NEW EMPLOYEE", error);
          const isAxiosError = error instanceof AxiosError;
          if (isAxiosError) {
            const errorReason = error?.response?.data?.error as string;
            toast.error(errorReason);
          } else {
            toast.error(error?.message);
          }
        },
      }
    );
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-xl">
          <DialogHeader>
            <DialogTitle>Take action on leave application</DialogTitle>
          </DialogHeader>

          <div className="mt-5">
            <Select value={value} onValueChange={setValue} disabled={isPending}>
              <span>Choose Action</span>
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Action..." />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Approved">Approved</SelectItem>
                <SelectItem value="Rejected">Rejected</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center justify-end">
            <Button onClick={submitAction} disabled={isPending}>
              Submit
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
